export default __webpack_public_path__ + "static/media/8.50ac74b7.mp3";